export default "\n  display: flex;\n  align-items: center;\n";